/* Retro Craft: Build Your Game Boy (sections/rc-gameboy-builder.liquid)
 * Reads window.RCGB_CONFIG (assets/rc-gb-config.js) for which products belong to each model and step, then
 * loads live prices, variants and stock from /products/<handle>.js. Pricing model: the build fee sits in the
 * base (supplied console or send-in build); mods cost their shop price; soldered mods add an installation line.
 * The supplied console is only offered while that model's Base Board is in stock.
 */
(function () {
  'use strict';
  var ART = window.GBBArt, CFG = window.RCGB_CONFIG;
  if (!ART || !CFG) return;

  // ---------- helpers ----------
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) { var n = cents / 100; return '$' + (n % 1 ? n.toFixed(2) : n.toFixed(0)); }
  function ref() { return 'GB-' + Math.random().toString(36).slice(2, 6).toUpperCase() + Date.now().toString(36).slice(-3).toUpperCase(); }
  function byId(list, id) { for (var i = 0; i < list.length; i++) if (list[i].key === id) return list[i]; return null; }

  // Colour name -> swatch for the drawing and the chips. Known names come from the sourcing palette;
  // anything else is worked out from its words ("Clear green yellow" -> translucent green).
  var WORD = { black: '#2a2930', white: '#f3f2ee', grey: '#c9c7c1', gray: '#c9c7c1', blue: '#2f5fc4', green: '#4fae5c', red: '#c62a35',
    purple: '#6a4bb0', yellow: '#f1c232', orange: '#ee7a2a', pink: '#ef8fb4', teal: '#1f9c98', duck: '#1f9c98', gold: '#c9a54a', silver: '#b9bcc4',
    brown: '#6e4a35', sapphire: '#2a4fb8', glacier: '#b9e0ee', coffee: '#7a5038', indigo: '#3f3c9e', rose: '#c2306a', beige: '#d8c9a8',
    tangerine: '#f07a2a', bluebell: '#6d7fd8', fluorescent: '#9fd3ff', chrome: '#c7cad1' };
  function swatch(name) {
    if (!name) return null;
    var k = name.toLowerCase(), pal = CFG.palette || {};
    if (pal[k]) return { hex: pal[k].hex, op: pal[k].op };
    var words = k.replace(/[^a-z ]/g, ' ').split(/\s+/), hex = null;
    for (var i = 0; i < words.length && !hex; i++) hex = WORD[words[i]];
    var clear = /clear|transparent|translucent|glacier|atomic/.test(k), glow = /glow/.test(k);
    if (glow) return { hex: '#cdeeb6', op: 0.9 };
    if (!hex) hex = clear ? '#dfe5ec' : '#9a98a6';
    return { hex: hex, op: clear ? 0.58 : 1 };
  }
  var LENS = { 'black': '#111114', 'grey': '#6d6b78', 'dmg grey': '#5a5967', 'white': '#f3f2ee', 'orange': '#ee7a2a', 'red': '#9b1c24',
    'silver': '#b9bcc4', 'light grey': '#c9c7c1', 'full clear': 'transparent' };
  function lensHex(name) { return name ? LENS[name.toLowerCase()] || null : null; }
  function isClear(name) { return /clear|transparent|translucent|glacier|atomic/i.test(name || ''); }
  function reg(name) { if (name && !ART.SWATCH[name]) { var s = swatch(name); if (s) ART.SWATCH[name] = s; } return name; }

  // ---------- data ----------
  var cache = {};
  function loadProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return cache[handle];
  }

  function Builder(root) {
    this.root = root;
    this.test = root.hasAttribute('data-test-mode');
    this.state = null;
    this.data = null;
    this.lead = root.getAttribute('data-lead') || '3 weeks';
    this.renderModels();
    this.bindAck();
  }

  // ---------- built-to-order acknowledgement (same pattern as the service builder pop-up) ----------
  // Add to cart / Finish test build opens the pop-up first; every box must be ticked before Confirm works.
  // Browsers without <dialog> (e.g. iOS before 15.4) get the same panel as a fixed overlay, so it is never skipped.
  Builder.prototype.bindAck = function () {
    var self = this, ack = this.root.querySelector('[data-ack]');
    this.ack = ack;
    if (!ack) return;
    this.ackFallback = typeof ack.showModal !== 'function';
    var boxes = ack.querySelectorAll('[data-ack-box]'), ok = ack.querySelector('[data-ack-confirm]');
    // only the statements showing count (the send-in statement is hidden for supplied consoles)
    var shown = function () { return Array.prototype.filter.call(boxes, function (b) { return !b.closest('[hidden]'); }); };
    this.ackShown = shown;
    var sync = function () { ok.disabled = shown().some(function (b) { return !b.checked; }); };
    boxes.forEach(function (b) { b.addEventListener('change', sync); });
    ack.querySelector('[data-ack-cancel]').addEventListener('click', function () { self.hideAck(); });
    ack.addEventListener('close', function () { self.afterAck(); });
    this.onAckKey = function (e) { if (e.key === 'Escape') self.hideAck(); };
    ok.addEventListener('click', function () {
      if (ok.disabled) return;
      var r = self.pending, text = self.ackText(shown());
      self.pending = null;
      self.hideAck();
      if (!r) return;
      if (self.test) self.finishTest(r); else self.addToCart(r, text);
    });
  };
  Builder.prototype.openAck = function (r) {
    var ack = this.ack;
    if (!ack) { if (this.test) this.finishTest(r); return; }   // no pop-up markup: never add to cart unacknowledged
    this.pending = r;
    ack.querySelectorAll('[data-ack-box]').forEach(function (b) { b.checked = false; });
    var si = ack.querySelector('[data-ack-sendin]'); if (si) si.hidden = this.state.base !== 'sendin';   // customer supplies the console
    ack.querySelector('[data-ack-confirm]').disabled = true;
    if (!this.ackFallback) { ack.showModal(); return; }
    ack.setAttribute('open', ''); ack.classList.add('is-fallback');
    document.addEventListener('keydown', this.onAckKey);
    ack.querySelector('[data-ack-box]').focus();
  };
  Builder.prototype.hideAck = function () {
    var ack = this.ack;
    if (!this.ackFallback) { if (ack.open) ack.close(); return; }
    ack.removeAttribute('open'); ack.classList.remove('is-fallback');
    document.removeEventListener('keydown', this.onAckKey);
    this.afterAck();
  };
  Builder.prototype.afterAck = function () {
    var add = this.root.querySelector('[data-add]');
    if (add && !add.disabled) add.focus({ preventScroll: true });
  };
  Builder.prototype.ackText = function (boxes) {
    var lines = boxes.map(function (b) { return '✓ ' + b.nextElementSibling.textContent.trim(); });
    return this.data.m.name + ' custom build ' + this.state.ref + ' acknowledged ' + new Date().toLocaleString('en-AU') + ':\n' + lines.join('\n');
  };
  // Save the acknowledgement as a cart attribute (appended, so several builds in one cart each keep theirs).
  function saveAck(text) {
    if (!text) return Promise.resolve();
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var prev = (cart.attributes && cart.attributes['Custom build acknowledgement']) || '';
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Custom build acknowledgement': prev ? prev + '\n\n' + text : text } }) });
    });
  }

  Builder.prototype.renderModels = function () {
    var html = '<div class="rcgb-models" role="radiogroup" aria-label="Choose your Game Boy">';
    CFG.models.forEach(function (m) {
      html += '<button type="button" class="rcgb-model" role="radio" aria-checked="false" data-model="' + m.code + '">' +
        '<span class="rcgb-model__art" aria-hidden="true">' + ART.draw(m.code, 'pick' + m.code) + '</span>' +
        '<span class="rcgb-model__name">' + esc(m.short) + '</span></button>';
    });
    html += '</div><div class="rcgb-work" data-work hidden></div>';
    // Phones / small tablets (layout stacks below 920px, so the build panel ends up at the very bottom): a slim bar
    // pinned to the bottom with a live mini drawing and the total; Preview opens a large drawing, Review jumps to the summary.
    html += '<div class="rcgb-bar" data-bar hidden>' +
      '<button type="button" class="rcgb-bar__thumb" data-bar-preview aria-label="Preview your build"><span data-bar-art></span></button>' +
      '<span class="rcgb-bar__text"><span data-bar-name></span><strong data-bar-total></strong></span>' +
      '<button type="button" class="rcgb-bar__btn" data-bar-preview>Preview</button>' +
      '<button type="button" class="rcgb-bar__btn rcgb-bar__btn--alt" data-bar-review>Review</button></div>' +
      '<dialog class="rcgb-sheet" data-sheet aria-labelledby="rcgb-sheet-title">' +
      '<button type="button" class="rcgb-sheet__x" data-sheet-close aria-label="Close preview">×</button>' +
      '<div class="rcgb-sheet__art" data-sheet-art></div>' +
      '<p class="rcgb-sheet__title" id="rcgb-sheet-title"><span data-sheet-name></span> · <strong data-sheet-total></strong></p>' +
      '<button type="button" class="rcgb-add rcgb-sheet__close" data-sheet-close>Back to building</button></dialog>';
    this.root.querySelector('[data-models]').innerHTML = html;
    this.bindBar();
    var self = this;
    this.root.querySelectorAll('.rcgb-model').forEach(function (b) {
      b.addEventListener('click', function () { self.pickModel(b.getAttribute('data-model')); });
    });
  };

  // ---------- mobile preview bar + large preview ----------
  Builder.prototype.bindBar = function () {
    var self = this, root = this.root, bar = root.querySelector('[data-bar]'), sheet = root.querySelector('[data-sheet]');
    this.bar = bar; this.sheet = sheet; this.sheetFallback = typeof sheet.showModal !== 'function';
    bar.querySelectorAll('[data-bar-preview]').forEach(function (b) { b.addEventListener('click', function () { self.openSheet(); }); });
    bar.querySelector('[data-bar-review]').addEventListener('click', function () {
      var sum = root.querySelector('.rcgb-panel');
      if (sum) sum.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
    sheet.querySelectorAll('[data-sheet-close]').forEach(function (b) { b.addEventListener('click', function () { self.closeSheet(); }); });
    sheet.addEventListener('click', function (e) { if (e.target === sheet) self.closeSheet(); });   // tap outside the panel
    sheet.addEventListener('close', function () { var t = bar.querySelector('.rcgb-bar__btn'); if (t) t.focus({ preventScroll: true }); });
    this.onSheetKey = function (e) { if (e.key === 'Escape') self.closeSheet(); };
    // hide the bar once the real build panel is on screen (it would only repeat it)
    var ticking = false, check = function () { ticking = false; self.placeBar(); };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    window.addEventListener('resize', check);
  };
  Builder.prototype.placeBar = function () {
    var bar = this.bar, panel = this.root.querySelector('.rcgb-panel');
    if (!bar || bar.hidden || !panel) return;
    bar.classList.toggle('is-away', panel.getBoundingClientRect().top < window.innerHeight - 90);
  };
  Builder.prototype.updateBar = function (lk, total) {
    var m = this.data.m, bar = this.bar, sheet = this.sheet;
    if (!bar) return;
    if (this.barCode !== m.code) {
      bar.querySelector('[data-bar-art]').innerHTML = ART.draw(m.code, 'bar');
      sheet.querySelector('[data-sheet-art]').innerHTML = ART.draw(m.code, 'sheet');
      this.barCode = m.code; this.barLook = null;
    }
    var lh = lensHex(lk.lens);
    [bar, sheet].forEach(function (el) {
      var svg = el.querySelector('svg'); if (!svg) return;
      ART.update(svg, lk); if (lh && lh !== 'transparent') svg.style.setProperty('--bezel', lh);
    });
    bar.querySelector('[data-bar-name]').textContent = 'Your ' + m.short;
    sheet.querySelector('[data-sheet-name]').textContent = 'Your ' + m.name;
    bar.querySelector('[data-bar-total]').textContent = sheet.querySelector('[data-sheet-total]').textContent = money(total);
    // a short pulse on the mini drawing when a choice changes how the console looks
    var key = JSON.stringify(lk), thumb = bar.querySelector('.rcgb-bar__thumb');
    if (this.barLook && this.barLook !== key) { thumb.classList.remove('is-pulse'); void thumb.offsetWidth; thumb.classList.add('is-pulse'); }
    this.barLook = key;
    bar.hidden = false;
    this.placeBar();
  };
  Builder.prototype.openSheet = function () {
    var sheet = this.sheet;
    if (!this.sheetFallback) { sheet.showModal(); return; }
    sheet.setAttribute('open', ''); sheet.classList.add('is-fallback');
    document.addEventListener('keydown', this.onSheetKey);
    sheet.querySelector('.rcgb-sheet__close').focus();
  };
  Builder.prototype.closeSheet = function () {
    var sheet = this.sheet;
    if (!this.sheetFallback) { if (sheet.open) sheet.close(); return; }
    sheet.removeAttribute('open'); sheet.classList.remove('is-fallback');
    document.removeEventListener('keydown', this.onSheetKey);
  };

  Builder.prototype.pickModel = function (code) {
    var self = this, m = CFG.models.filter(function (x) { return x.code === code; })[0];
    this.root.querySelectorAll('.rcgb-model').forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-model') === code ? 'true' : 'false'); });
    var work = this.root.querySelector('[data-work]');
    work.hidden = false;
    work.innerHTML = '<p class="rcgb-loading" role="status">Loading ' + esc(m.name) + ' options…</p>';
    var handles = [m.base.sendin.handle, m.base.supplied.handle, CFG.installHandle].concat(m.base.fpgbc ? [m.base.fpgbc.handle] : [])
      .concat(m.packages.map(function (p) { return p.handle; })).concat(m.parts.map(function (p) { return p.handle; }));
    Promise.all(handles.map(loadProduct)).then(function (res) {
      var prod = {}; handles.forEach(function (h, i) { prod[h] = res[i]; });
      self.data = { m: m, prod: prod };
      self.state = { model: code, base: null, pkg: null, pkgOpt: {}, shell: null, shellColour: null, buttons: null, btn: {},
        on: {}, audio: null, lens: null, ref: ref() };
      var sendin = prod[m.base.sendin.handle], sup = prod[m.base.supplied.handle];
      self.state.base = sup && sup.available ? 'supplied' : (sendin ? 'sendin' : null);
      self.renderWork();
      var top = work.getBoundingClientRect().top + window.scrollY - 120;
      if (window.scrollY < top - 200) window.scrollTo({ top: top, behavior: 'smooth' });
    });
  };

  // ---------- derived ----------
  Builder.prototype.variantFor = function (product, opts) {
    if (!product) return null;
    var names = product.options.map(function (o) { return o.name || o; });
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i], ok = true;
      for (var j = 0; j < names.length; j++) if (opts[names[j]] != null && v.options[j] !== opts[names[j]]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  };
  Builder.prototype.optionValues = function (product, name, fixed) {
    // values of option `name` that exist for the other options already chosen (`fixed`)
    var names = product.options.map(function (o) { return o.name || o; }), idx = names.indexOf(name), out = [];
    product.variants.forEach(function (v) {
      for (var j = 0; j < names.length; j++) if (j !== idx && fixed[names[j]] != null && v.options[j] !== fixed[names[j]]) return;
      if (out.indexOf(v.options[idx]) < 0 && v.available !== false) out.push(v.options[idx]);
    });
    return out;
  };
  Builder.prototype.pkg = function () { return this.state.pkg ? byId(this.data.m.packages, this.state.pkg) : null; };
  Builder.prototype.part = function (key) { return byId(this.data.m.parts, key); };
  Builder.prototype.prod = function (h) { return this.data.prod[h]; };
  Builder.prototype.pkgHasBattery = function () {
    var p = this.pkg(); return !!(p && p.hasBattery && this.state.pkgOpt.Battery === 'With USB-C battery');
  };
  Builder.prototype.excluded = function (key) {
    // returns the reason if `key` is ruled out by the current selection
    var st = this.state, self = this, why = null;
    (this.data.m.excludes || []).forEach(function (r) {
      var a = r[0], b = r[1];
      // a: an add-on key, a screen package ('PKG-<key>'), or a package's bundled battery ('PKG-<key>#battery')
      var aOn = a.indexOf('#battery') > 0 ? (st.pkg && 'PKG-' + st.pkg + '#battery' === a && self.pkgHasBattery())
        : a.indexOf('PKG-') === 0 ? (st.pkg && 'PKG-' + st.pkg === a) : !!st.on[a];
      var bOn = !!st.on[b];
      if (key === b && aOn) why = r[2];
      if (key === a && bOn && a.indexOf('#') < 0 && a.indexOf('PKG-') !== 0) why = r[2];
    });
    return why;
  };
  Builder.prototype.needsShellStep = function () {
    var p = this.pkg(); return this.state.base === 'fpgbc' || !p || !p.shellIncluded;
  };
  Builder.prototype.lensAllowed = function () {
    if (this.state.base === 'fpgbc') return false;
    var p = this.pkg(); return !p || p.originalSize;
  };

  // ---------- render ----------
  Builder.prototype.renderWork = function () {
    var d = this.data, m = d.m, st = this.state, self = this, P = d.prod;
    var steps = [];
    // 1. Console
    var sup = P[m.base.supplied.handle], sendin = P[m.base.sendin.handle], fp = m.base.fpgbc && P[m.base.fpgbc.handle];
    var sendinV = sendin && self.variantFor(sendin, { Model: m.name });
    var baseOpts = [];
    if (sup) baseOpts.push({ id: 'supplied', title: 'Supplied console', price: sup.price, note: sup.available ? 'A genuine ' + m.name + ', cleaned and fully recapped, as the base of your build.' : 'None in stock right now. Choose a send-in build, or check back soon.', disabled: !sup.available });
    if (sendinV) baseOpts.push({ id: 'sendin', title: 'Send-in build', price: sendinV.price, note: 'Post us your own ' + m.name + '. Teardown, deep clean, assembly, testing and return postage included.' });
    if (fp) baseOpts.push({ id: 'fpgbc', title: 'Brand-new FPGBC console', price: fp.price, note: 'FunnyPlaying’s modern GBC board with a laminated Retro Pixel screen built in.', disabled: !fp.available });
    steps.push(this.stepHTML('base', 'Console', 'How do you want to start?', this.cardsHTML('base', baseOpts, st.base)));

    // 2. Screen
    if (st.base !== 'fpgbc') {
      // tiered models: card title is the tier (Original, IPS Original, ...) and the kit name leads the description
      var tiered = m.packages.some(function (p) { return p.tier; });
      var scr = [{ id: '', title: tiered ? 'Original' : 'Keep the original screen', price: 0, note: tiered ? 'Keep the original screen. No screen upgrade.' : 'No screen upgrade.' }];
      m.packages.forEach(function (p) {
        var pr = P[p.handle]; if (!pr || !pr.available) return;
        var noB = self.variantFor(pr, p.hasBattery ? { Battery: 'No battery' } : {});
        var pfee = self.feeVariant(p);
        scr.push({ id: p.key, title: p.tier || p.title, price: (noB || pr).price + (pfee ? pfee.price : 0), from: pr.price_min !== pr.price_max,
          note: (p.tier ? p.title + '. ' : '') + p.blurb + (pfee ? ' Price includes installation.' : ''), info: p.info });
      });
      var scrHTML = this.cardsHTML('pkg', scr, st.pkg || '');
      var pp = this.pkg();
      if (pp) scrHTML += this.optionsHTML(P[pp.handle], pp);
      steps.push(this.stepHTML('screen', 'Screen', 'Pick a screen package. Packages marked “+ Shell” include a new shell made to fit.', scrHTML));
    }
    // 3. Shell
    if (this.needsShellStep()) {
      // a larger screen kept in the original shell needs that shell trimming: say so on the keep option
      var trim = st.base !== 'fpgbc' && this.pkg() && this.pkg().trimShell;
      var shells = [{ id: '', title: st.base === 'fpgbc' ? 'Standard FPGBC shell' : 'Keep the original shell', price: 0,
        note: trim ? 'The original shell will need minor modification to fit this screen. Choose a new shell to avoid this.' : '', warn: trim }];
      ['SHELL', 'XRSHELL'].forEach(function (k) { var pt = self.part(k), pr = pt && P[pt.handle]; if (pr && pr.available) shells.push({ id: k, title: pt.title, price: pr.price, note: pt.blurb }); });
      var shHTML = this.cardsHTML('shell', shells, st.shell || '');
      if (st.shell) shHTML += this.chipsHTML('shellColour', 'Shell colour', P[this.part(st.shell).handle], 'Colour', st.shellColour);
      steps.push(this.stepHTML('shell', 'Shell', '', shHTML));
    }
    function group(g) {
      var items = m.parts.filter(function (pt) { return pt.step === g[0]; });
      if (g[0] === 'lens' && !self.lensAllowed()) return;
      if (g[0] === 'service' && st.base !== 'sendin') return;
      var rows = items.map(function (pt) {
        var pr = P[pt.handle]; if (!pr || !pr.available) return '';
        if (pt.key === 'USBC' && self.pkgHasBattery()) return '';
        var why = self.excluded(pt.key), fee = self.feeVariant(pt), on = !!st.on[pt.key];
        var input = g[2] === 'radio' ? '<input type="radio" name="rcgb-' + g[0] + '" data-radio="' + g[0] + '" value="' + pt.key + '"' + (st.audio === pt.key ? ' checked' : '') + (why ? ' disabled' : '') + '>'
          : '<input type="checkbox" data-check="' + pt.key + '"' + (on ? ' checked' : '') + (why ? ' disabled' : '') + '>';
        var extra = (pt.option && pt.option !== 'Colour' && (on || st.audio === pt.key)) ? self.chipsHTML('opt:' + pt.key, pt.option, pr, pt.option, (st.on[pt.key] || {})[pt.option]) : '';
        return '<div class="rcgb-row' + (why ? ' is-off' : '') + '"><label class="rcgb-check">' + input +
          '<span class="rcgb-check__body"><span class="rcgb-check__title">' + esc(pt.title) + '</span>' +
          '<span class="rcgb-check__note">' + esc(why || pt.blurb) + '</span></span>' +
          '<span class="rcgb-price">' + money(fee ? fee.price : pr.price) + '</span></label>' + extra + '</div>';
      }).join('');
      if (g[2] === 'radio' && rows) rows = '<div class="rcgb-row"><label class="rcgb-check"><input type="radio" name="rcgb-' + g[0] + '" data-radio="' + g[0] + '" value=""' + (!st.audio ? ' checked' : '') + '><span class="rcgb-check__body"><span class="rcgb-check__title">Keep the original</span></span><span class="rcgb-price">—</span></label></div>' + rows;
      var hint = g[0] === 'service' ? 'For consoles you send in.' : g[0] === 'feel' ? 'Choose lighting first: it changes which buttons we recommend.' : '';
      if (rows) steps.push(self.stepHTML(g[0], g[1], hint, rows));
    }
    // 4. Lighting & button feel, before buttons (RGB changes the button recommendation)
    group(['feel', 'Lighting & button feel', 'check']);
    // 5. Buttons
    var btn = [{ id: '', title: 'Keep the original buttons', price: 0, note: '' }];
    ['BTN', 'PREMBTN'].forEach(function (k) { var pt = self.part(k), pr = pt && P[pt.handle]; if (pr && pr.available) btn.push({ id: k, title: pt.title, price: pr.price, note: pt.blurb }); });
    var bHTML = this.cardsHTML('buttons', btn, st.buttons || '');
    if (st.buttons) bHTML += this.buttonColoursHTML(P[this.part(st.buttons).handle]);
    if (btn.length > 1) steps.push(this.stepHTML('buttons', 'Buttons', '', bHTML));
    // 6. remaining add-on groups
    [['audio', 'Audio', 'radio'], ['power', 'Power', 'check'], ['video', 'TV output', 'check'], ['lens', 'Screen lens', 'check'],
     ['service', 'Servicing', 'check'], ['extras', 'Extras', 'check']].forEach(group);

    var work = this.root.querySelector('[data-work]');
    work.innerHTML = '<div class="rcgb-layout"><div class="rcgb-steps">' + steps.join('') + '</div>' +
      '<aside class="rcgb-panel" aria-label="Your build"><div class="rcgb-stage">' + ART.draw(m.code, 'stage') + '</div>' +
      '<div class="rcgb-sum" data-sum></div></aside></div>';
    if (!work.__rcgbBound) { this.bind(work); work.__rcgbBound = true; }  // once: the container survives re-renders
    work.querySelectorAll('[data-more]').forEach(moreBind);              // new cards each render, so bind their info pop-ups
    this.refreshPanel();
  };

  Builder.prototype.stepHTML = function (id, title, hint, body) {
    return '<section class="rcgb-step" data-step="' + id + '"><h2 class="rcgb-step__title">' + esc(title) + '</h2>' +
      (hint ? '<p class="rcgb-step__hint">' + esc(hint) + '</p>' : '') + '<div class="rcgb-step__body">' + body + '</div></section>';
  };
  Builder.prototype.cardsHTML = function (name, opts, cur) {
    return '<div class="rcgb-cards" role="radiogroup">' + opts.map(function (o) {
      var sel = String(cur) === String(o.id);
      var card = '<button type="button" class="rcgb-card" role="radio" aria-checked="' + sel + '" data-pick="' + name + '" data-value="' + esc(o.id) + '"' + (o.disabled ? ' disabled' : '') + '>' +
        '<span class="rcgb-card__title">' + esc(o.title) + '</span>' + (o.note ? '<span class="rcgb-card__note' + (o.warn ? ' rcgb-card__note--warn' : '') + '">' + esc(o.note) + '</span>' : '') +
        '<span class="rcgb-price">' + (o.price ? (o.from ? 'from ' : '') + money(o.price) : 'Included') + '</span></button>';
      if (!o.info || !o.info.length) return card;
      // "More info" sits beside the card (a button can't hold another button) and is pulled up into its bottom edge,
      // the same pattern as the service builder.
      var pid = 'rcgb-more-' + name + '-' + String(o.id).replace(/[^A-Za-z0-9_-]/g, '');
      return '<div class="rcgb-cardwrap">' + card + '<div class="rcgb-more" data-more>' +
        '<button type="button" class="rcgb-more__btn" aria-expanded="false" aria-controls="' + pid + '" data-more-btn>' +
        '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7.5v.5" stroke-linecap="round"/></svg>' +
        '<span>More info</span><span class="visually-hidden"> about ' + esc(o.title) + '</span></button>' +
        '<div class="rcgb-more__pop" id="' + pid + '" role="region" aria-label="More info: ' + esc(o.title) + '" data-more-pop hidden>' +
        o.info.map(function (t) { return '<p>' + esc(t) + '</p>'; }).join('') + '</div></div></div>';
    }).join('') + '</div>';
  };
  // More info pop-ups: hover or keyboard focus opens on desktop, tap toggles on touch, Escape or a click elsewhere
  // closes, and a click pins it open. Cards are rebuilt on every change, so each render binds its own triggers.
  var moreHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches, moreRefocus = false;
  function moreOpen(wrap, open) {
    var btn = wrap.querySelector('[data-more-btn]'), pop = wrap.querySelector('[data-more-pop]');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    pop.hidden = !open;
    wrap.classList.toggle('is-open', open);
    if (!open) { wrap.removeAttribute('data-pinned'); return; }
    pop.classList.remove('rcgb-more__pop--end');
    if (pop.getBoundingClientRect().right > document.documentElement.clientWidth - 8) pop.classList.add('rcgb-more__pop--end');
    var b = btn.getBoundingClientRect(), p = pop.getBoundingClientRect();
    pop.style.setProperty('--rcgb-more-arrow', Math.max(12, Math.min(p.width - 24, b.left + 14 - p.left)) + 'px');
  }
  function moreCloseAll(except) { document.querySelectorAll('.rcgb [data-more]').forEach(function (w) { if (w !== except) moreOpen(w, false); }); }
  function moreBind(wrap) {
    var btn = wrap.querySelector('[data-more-btn]'), timer;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var pinned = wrap.hasAttribute('data-pinned');
      moreCloseAll(wrap);
      if (pinned) moreOpen(wrap, false); else { moreOpen(wrap, true); wrap.setAttribute('data-pinned', ''); }
    });
    if (moreHover) {
      wrap.addEventListener('mouseenter', function () { clearTimeout(timer); moreCloseAll(wrap); moreOpen(wrap, true); });
      wrap.addEventListener('mouseleave', function () { if (!wrap.hasAttribute('data-pinned')) timer = setTimeout(function () { moreOpen(wrap, false); }, 150); });
    }
    btn.addEventListener('focus', function () { if (!moreRefocus && btn.matches(':focus-visible')) { moreCloseAll(wrap); moreOpen(wrap, true); } });
    wrap.addEventListener('focusout', function (e) { if (!wrap.contains(e.relatedTarget) && !wrap.hasAttribute('data-pinned')) moreOpen(wrap, false); });
  }
  document.addEventListener('click', function (e) { if (!e.target.closest('.rcgb [data-more]')) moreCloseAll(); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.rcgb [data-more-btn][aria-expanded="true"]');
    if (open) { moreCloseAll(); moreRefocus = true; open.focus(); moreRefocus = false; }
  });
  Builder.prototype.chipsHTML = function (key, label, product, optName, cur, fixed) {
    if (!product) return '';
    var vals = this.optionValues(product, optName, fixed || {});
    if (!vals.length) return '';
    var isLens = /lens/i.test(optName);
    return '<div class="rcgb-ddrow">' + this.ddHTML(key, label, vals.map(function (v) {
      return isLens ? { value: v, label: v + ' lens', shell: null, ring: v, lensOnly: true } : { value: v, label: v, shell: v };
    }), cur, { placeholder: isLens ? 'Choose a lens' : 'Choose a colour' }) + '</div>';
  };
  Builder.prototype.swatchHTML = function (shellName, ringName) {
    var s = swatch(shellName), ring = lensHex(ringName);
    if (!s && ring) return '<i style="background:' + (ring === 'transparent' ? 'rgba(255,255,255,.12)' : ring) + ';box-shadow:0 0 0 1px rgba(255,255,255,.45)"></i>';
    if (!s) return '';
    return '<i style="background:' + s.hex + ';opacity:' + Math.max(s.op, 0.45) + (ring ? ';box-shadow:0 0 0 3px ' + (ring === 'transparent' ? 'rgba(255,255,255,.5)' : ring) + ',0 0 0 4px rgba(255,255,255,.35)' : '') + '"></i>';
  };
  // items: [{value, label, sub, shell, ring, rec}]; one open at a time; selecting calls chip(key, value)
  Builder.prototype.ddHTML = function (key, label, items, cur, opts) {
    opts = opts || {}; var self = this, id = 'rcgb-dd-' + key.replace(/[^a-z0-9]/gi, '') + '-' + this.state.ref;
    var sel = items.filter(function (it) { return it.value === cur; })[0];
    var face = sel ? this.swatchHTML(sel.shell, sel.ring) + '<span class="rcgb-dd__text">' + esc(sel.label) + (sel.sub ? ' <small>\u00b7 ' + esc(sel.sub) + '</small>' : '') + '</span>'
      : '<span class="rcgb-dd__text rcgb-dd__placeholder">' + esc(opts.placeholder || 'Choose a colour') + '</span>';
    return '<div class="rcgb-dd' + (opts.compact ? ' is-compact' : '') + '" data-dd="' + esc(key) + '">' +
      (label ? '<span class="rcgb-dd__label" id="' + id + '-l">' + esc(label) + '</span>' : '') +
      '<button type="button" class="rcgb-dd__btn" aria-haspopup="listbox" aria-expanded="false" aria-controls="' + id + '"' + (label ? ' aria-labelledby="' + id + '-l ' + id + '-b"' : '') + ' id="' + id + '-b">' + face + '<span class="rcgb-dd__caret" aria-hidden="true"></span></button>' +
      '<ul class="rcgb-dd__list" role="listbox" id="' + id + '" tabindex="-1" hidden>' + items.map(function (it) {
        return '<li role="option" class="rcgb-dd__opt' + (it.rec ? ' is-rec' : '') + '" aria-selected="' + (it.value === cur) + '" data-dd-opt="' + esc(it.value) + '">' +
          self.swatchHTML(it.shell, it.ring) + '<span class="rcgb-dd__text">' + esc(it.label) + (it.sub ? ' <small>\u00b7 ' + esc(it.sub) + '</small>' : '') + '</span>' +
          (it.rec ? '<span class="rcgb-rec">Recommended</span>' : '') + '</li>';
      }).join('') + '</ul></div>';
  };
  Builder.prototype.buttonColoursHTML = function (product) {
    if (!product) return '';
    var st = this.state, self = this, rgb = !!st.on.RGB, vals = this.optionValues(product, 'Colour', {});
    if (rgb) vals = vals.filter(isClear).concat(vals.filter(function (v) { return !isClear(v); }));
    var parts = this.data.m.buttonParts, mix = st.btnMode === 'mix';
    var all = parts.every(function (pp) { return st.btn[pp[0]] && st.btn[pp[0]] === st.btn[parts[0][0]]; }) ? st.btn[parts[0][0]] : null;
    var html = (rgb ? '<p class="rcgb-note">With the RGB kit, clear buttons let the light shine through, so they\u2019re listed first.</p>' : '') +
      '<div class="rcgb-seg" role="radiogroup" aria-label="Button colours">' +
      '<button type="button" class="rcgb-seg__btn" role="radio" aria-checked="' + !mix + '" data-pick="btnmode" data-value="all">All buttons</button>' +
      '<button type="button" class="rcgb-seg__btn" role="radio" aria-checked="' + mix + '" data-pick="btnmode" data-value="mix">Mix button colours</button></div>';
    var items = vals.map(function (v) { return { value: v, label: v, shell: v, rec: rgb && isClear(v) }; });
    if (!mix) html += '<div class="rcgb-ddrow">' + this.ddHTML('btnAll', 'Colour', items, all) + '</div>';
    else html += '<div class="rcgb-mixgrid">' + parts.map(function (pp) { return self.ddHTML('btn:' + pp[0], pp[1], items, st.btn[pp[0]]); }).join('') + '</div>';
    return '<div class="rcgb-btncolours">' + html + '</div>';
  };
  Builder.prototype.optionsHTML = function (product, p) {
    if (!product) return '';
    var st = this.state, html = '', names = product.options.map(function (o) { return o.name || o; }), self = this;
    var combo = names.indexOf('Shell colour') >= 0 && names.indexOf('Lens') >= 0;
    if (combo) names = names.filter(function (n) { return n === 'Battery'; }).concat(['__combo']);
    names.forEach(function (n) {
      if (n === 'Title') return;
      if (n === '__combo') {
        var all = product.options.map(function (o) { return o.name || o; }), si = all.indexOf('Shell colour'), li = all.indexOf('Lens'), bi = all.indexOf('Battery'), seen = {}, chips = [];
        product.variants.forEach(function (v) {
          if (v.available === false) return;
          if (bi >= 0 && st.pkgOpt.Battery && v.options[bi] !== st.pkgOpt.Battery) return;
          var k = v.options[si] + '||' + v.options[li]; if (seen[k]) return; seen[k] = 1; chips.push([v.options[si], v.options[li]]);
        });
        var cur = st.pkgOpt['Shell colour'] && st.pkgOpt.Lens ? st.pkgOpt['Shell colour'] + '||' + st.pkgOpt.Lens : null;
        html += '<div class="rcgb-ddrow">' + self.ddHTML('pkgcombo', 'Shell & lens', chips.map(function (c) {
          return { value: c[0] + '||' + c[1], label: c[0] + ' shell', sub: c[1] + ' lens', shell: c[0], ring: c[1] };
        }), cur, { placeholder: 'Choose a shell & lens' }) + '</div>';
        return;
      }
      var fixed = {}; names.forEach(function (o) { if (o !== n && st.pkgOpt[o] != null) fixed[o] = st.pkgOpt[o]; });
      if (n === 'Battery') {
        var vals = self.optionValues(product, 'Battery', fixed);
        if (vals.length) {
          var noV = self.variantFor(product, Object.assign({}, fixed, { Battery: 'No battery' })), yesV = self.variantFor(product, Object.assign({}, fixed, { Battery: 'With USB-C battery' }));
          html += '<fieldset class="rcgb-chips"><legend>USB-C battery</legend><div class="rcgb-chips__row">' + vals.map(function (v) {
            var diff = (noV && yesV && v === 'With USB-C battery') ? ' (+' + money(yesV.price - noV.price) + ')' : '';
            return '<button type="button" class="rcgb-chip" aria-pressed="' + (st.pkgOpt.Battery === v) + '" data-chip="pkg:Battery" data-value="' + esc(v) + '">' + esc(v) + diff + '</button>';
          }).join('') + '</div></fieldset>';
        }
        return;
      }
      html += self.chipsHTML('pkg:' + n, n, product, n, st.pkgOpt[n], fixed);
    });
    return '<div class="rcgb-pkgopts">' + html + '</div>';
  };

  Builder.prototype.feeVariant = function (item) {
    if (!item || !item.feeSku) return null;
    var ins = this.data.prod[CFG.installHandle]; if (!ins) return null;
    for (var i = 0; i < ins.variants.length; i++) if (ins.variants[i].sku === item.feeSku) return ins.variants[i];
    return null;
  };

  // ---------- events ----------
  Builder.prototype.bind = function (work) {
    var self = this;
    work.addEventListener('click', function (e) {
      var ddb = e.target.closest('.rcgb-dd__btn');
      if (ddb) { var dd = ddb.closest('[data-dd]'); self.ddToggle(dd, ddb.getAttribute('aria-expanded') !== 'true'); return; }
      var opt = e.target.closest('[data-dd-opt]');
      if (opt) { self.chip(opt.closest('[data-dd]').getAttribute('data-dd'), opt.getAttribute('data-dd-opt'), true); return; }
      var c = e.target.closest('[data-pick]'), ch = e.target.closest('[data-chip]');
      if (c && !c.disabled) { self.pick(c.getAttribute('data-pick'), c.getAttribute('data-value')); return; }
      if (ch) { self.chip(ch.getAttribute('data-chip'), ch.getAttribute('data-value')); }
    });
    work.addEventListener('keydown', function (e) {
      var dd = e.target.closest && e.target.closest('[data-dd]'); if (!dd) return;
      var list = dd.querySelector('.rcgb-dd__list'), btn = dd.querySelector('.rcgb-dd__btn'), open = !list.hidden;
      var opts = [].slice.call(list.querySelectorAll('[data-dd-opt]')), i = opts.indexOf(list.querySelector('.is-active'));
      function move(n) { opts.forEach(function (o) { o.classList.remove('is-active'); }); var o = opts[Math.max(0, Math.min(opts.length - 1, n))]; if (o) { o.classList.add('is-active'); list.setAttribute('aria-activedescendant', o.id = o.id || ('o' + Math.random().toString(36).slice(2, 8))); o.scrollIntoView({ block: 'nearest' }); } }
      if (!open && (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); self.ddToggle(dd, true); return; }
      if (!open) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); move(i + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); move(i - 1); }
      else if (e.key === 'Home') { e.preventDefault(); move(0); }
      else if (e.key === 'End') { e.preventDefault(); move(opts.length - 1); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (opts[i]) self.chip(dd.getAttribute('data-dd'), opts[i].getAttribute('data-dd-opt'), true); }
      else if (e.key === 'Escape' || e.key === 'Tab') { self.ddToggle(dd, false); if (e.key === 'Escape') btn.focus(); }
      else if (e.key.length === 1) { var k = e.key.toLowerCase(), j = opts.findIndex(function (o, n) { return n > i && o.textContent.trim().toLowerCase().indexOf(k) === 0; }); if (j < 0) j = opts.findIndex(function (o) { return o.textContent.trim().toLowerCase().indexOf(k) === 0; }); if (j >= 0) move(j); }
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-dd]')) self.root.querySelectorAll('[data-dd]').forEach(function (d) { self.ddToggle(d, false); }); });
    work.addEventListener('change', function (e) {
      var t = e.target;
      if (t.hasAttribute('data-check')) { var k = t.getAttribute('data-check'); if (t.checked) self.state.on[k] = self.state.on[k] || {}; else delete self.state.on[k]; self.rerender(t); }
      if (t.hasAttribute('data-radio')) { var g = t.getAttribute('data-radio'); if (g === 'audio') { ['AMP', 'SPK'].forEach(function (k) { delete self.state.on[k]; }); self.state.audio = t.value || null; if (t.value) self.state.on[t.value] = {}; } self.rerender(t); }
    });
  };
  Builder.prototype.ddToggle = function (dd, open) {
    var self = this, list = dd.querySelector('.rcgb-dd__list'), btn = dd.querySelector('.rcgb-dd__btn');
    if (open) this.root.querySelectorAll('[data-dd]').forEach(function (d) { if (d !== dd) self.ddToggle(d, false); });
    list.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false'); dd.classList.toggle('is-open', open);
    if (open) { var s = list.querySelector('[aria-selected="true"]') || list.querySelector('[data-dd-opt]'); list.querySelectorAll('.is-active').forEach(function (o) { o.classList.remove('is-active'); }); if (s) { s.classList.add('is-active'); s.scrollIntoView({ block: 'nearest' }); } list.focus({ preventScroll: true }); }
  };
  Builder.prototype.rerender = function (focusEl) {
    var y = window.scrollY, step = focusEl && focusEl.closest('[data-step]'), sid = step && step.getAttribute('data-step');
    this.renderWork();
    window.scrollTo(0, y);
    if (sid) { var sel = focusEl && focusEl.id && document.getElementById(focusEl.id); var el = (sel && sel.tagName === 'SELECT') ? sel : this.root.querySelector('[data-step="' + sid + '"] [aria-checked="true"], [data-step="' + sid + '"] input:checked'); if (el && el.focus) el.focus({ preventScroll: true }); }
  };
  Builder.prototype.pick = function (name, value) {
    var st = this.state;
    if (name === 'base') { st.base = value; if (value === 'fpgbc') { st.pkg = null; st.pkgOpt = {}; } if (value !== 'sendin') ['CAPS', 'PADS', 'HINGE'].forEach(function (k) { delete st.on[k]; }); }
    if (name === 'pkg') { st.pkg = value || null; st.pkgOpt = {}; if (this.pkg() && this.pkg().shellIncluded) { st.shell = null; st.shellColour = null; } if (!this.lensAllowed()) delete st.on.LENS; }
    if (name === 'shell') { st.shell = value || null; st.shellColour = null; }
    if (name === 'buttons') { st.buttons = value || null; st.btn = {}; }
    if (name === 'btnmode') { st.btnMode = value; if (value === 'all') { var first = st.btn[this.data.m.buttonParts[0][0]]; var same = this.data.m.buttonParts.every(function (pp) { return st.btn[pp[0]] === first; }); if (!same) st.btn = {}; } }
    if (this.pkgHasBattery()) delete st.on.USBC;
    var self2 = this; Object.keys(st.on).forEach(function (k) { if (self2.excluded(k)) delete st.on[k]; });   // e.g. HDMI dropped when a laminated screen is picked
    var b = this.root.querySelector('[data-pick="' + name + '"][data-value="' + value + '"]');
    this.rerender(b);
  };
  Builder.prototype.chip = function (key, value, fromDd) {
    var st = this.state;
    if (key.indexOf('pkg:') === 0) {
      st.pkgOpt[key.slice(4)] = value; if (this.pkgHasBattery()) delete st.on.USBC;
      var pp = this.pkg(), pr = pp && this.prod(pp.handle);
      if (pr && key === 'pkg:Battery' && st.pkgOpt['Shell colour'] && !this.variantFor(pr, st.pkgOpt)) { delete st.pkgOpt['Shell colour']; delete st.pkgOpt.Lens; }
    }
    else if (key === 'shellColour') st.shellColour = value;
    else if (key === 'btnAll') { this.data.m.buttonParts.forEach(function (pp) { st.btn[pp[0]] = value; }); }
    else if (key.indexOf('btn:') === 0) st.btn[key.slice(4)] = value;
    else if (key === 'pkgcombo') { var sl = value.split('||'); st.pkgOpt['Shell colour'] = sl[0]; st.pkgOpt.Lens = sl[1]; }
    else if (key.indexOf('opt:') === 0) { var k = key.slice(4), pt = this.part(k); st.on[k] = st.on[k] || {}; st.on[k][pt.option] = value; }
    this.rerender(this.root.querySelector('[data-chip="' + key + '"]'));
    if (fromDd) { var b = this.root.querySelector('[data-dd="' + key + '"] .rcgb-dd__btn'); if (b) b.focus({ preventScroll: true }); }
  };

  // ---------- lines, totals, cart ----------
  Builder.prototype.lines = function () {
    var d = this.data, m = d.m, st = this.state, P = d.prod, L = [], missing = [], self = this;
    function add(product, variant, label, detail) { if (variant) L.push({ id: variant.id, price: variant.price, label: label, detail: detail || '' }); }
    if (st.base === 'supplied') { var s = P[m.base.supplied.handle]; add(s, s && s.variants[0], 'Supplied console', 'Cleaned and recapped'); }
    else if (st.base === 'sendin') { var si = P[m.base.sendin.handle]; add(si, this.variantFor(si, { Model: m.name }), 'Send-in build', 'Your own console'); }
    else if (st.base === 'fpgbc') { var f = P[m.base.fpgbc.handle]; add(f, f && f.variants[0], 'Brand-new FPGBC console', ''); }
    else missing.push('a console option');
    var p = this.pkg();
    if (p) {
      var pr = P[p.handle], names = pr.options.map(function (o) { return o.name || o; });
      var need = names.filter(function (n) { return n !== 'Title' && st.pkgOpt[n] == null && self.optionValues(pr, n, {}).length > 1; });
      var opts = Object.assign({}, st.pkgOpt);
      names.forEach(function (n) { if (opts[n] == null) { var vals = self.optionValues(pr, n, opts); if (vals.length === 1) opts[n] = vals[0]; } });
      var v = need.length ? null : this.variantFor(pr, opts);
      if (v) add(pr, v, p.title, v.public_title || ''); else missing.push('the ' + need.map(function (n) { return n.toLowerCase(); }).join(' and ').replace('shell colour and lens', 'shell & lens') + ' for your screen');
      if (p.feeSku) { var fv = this.feeVariant(p); if (fv) L.push({ id: fv.id, price: fv.price, label: 'HDMI board installation', detail: '', merge: true }); }
    }
    if (this.needsShellStep() && st.shell) {
      var sp = P[this.part(st.shell).handle];
      if (st.shellColour) add(sp, this.variantFor(sp, { Colour: st.shellColour }), this.part(st.shell).title, st.shellColour); else missing.push('a shell colour');
    }
    if (st.buttons) {
      var bp = P[this.part(st.buttons).handle];
      var bpParts = m.buttonParts, chosen = bpParts.filter(function (pp) { return st.btn[pp[0]]; });
      if (chosen.length === bpParts.length) {
        var same = bpParts.every(function (pp) { return st.btn[pp[0]] === st.btn[bpParts[0][0]]; });
        var det = same ? st.btn[bpParts[0][0]] : bpParts.map(function (pp) { return pp[1].replace(' / ', '/') + ': ' + st.btn[pp[0]]; }).join(', ');
        add(bp, this.variantFor(bp, { Colour: st.btn.ab || st.btn[bpParts[0][0]] }), this.part(st.buttons).title, det);
      } else missing.push('button colours (' + bpParts.filter(function (pp) { return !st.btn[pp[0]]; }).map(function (pp) { return pp[1]; }).join(', ') + ')');
    }
    Object.keys(st.on).forEach(function (k) {
      var pt = self.part(k); if (!pt) return; var pr = P[pt.handle]; if (!pr) return;
      if (self.excluded(k)) return;
      var v = pt.option ? self.variantFor(pr, st.on[k]) : pr.variants[0];
      if (pt.option && !st.on[k][pt.option]) { missing.push('the ' + pt.option.toLowerCase() + ' for ' + pt.title); return; }
      var fv = self.feeVariant(pt);
      if (fv) add(null, fv, pt.title, pt.option ? st.on[k][pt.option] : '');
      else add(pr, v, pt.title, pt.option ? st.on[k][pt.option] : '');
    });
    return { lines: L, missing: missing };
  };
  Builder.prototype.look = function () {
    var st = this.state, p = this.pkg(), shell = null;
    if (p && p.shellIncluded) shell = st.pkgOpt['Shell colour'] || null; else if (st.shell) shell = st.shellColour;
    var lookScreen = st.base === 'fpgbc' ? { size: 'stock', laminated: true, style: 'retro' } : (p ? p.look : null);
    var bt = null; if (st.buttons) { bt = {}; Object.keys(st.btn).forEach(function (k) { bt[k] = reg(st.btn[k]); }); }
    return { shell: reg(shell), buttons: bt, lens: p && p.shellIncluded ? st.pkgOpt.Lens : null, rgb: !!st.on.RGB, usbc: this.pkgHasBattery() || !!st.on.USBC || !!st.on.USBC_SP, screen: lookScreen };
  };
  Builder.prototype.displayLines = function (lines) {
    var out = [];
    lines.forEach(function (l) { if (l.merge && out.length) { out[out.length - 1] = Object.assign({}, out[out.length - 1], { price: out[out.length - 1].price + l.price }); } else out.push(l); });
    return out;
  };
  Builder.prototype.refreshPanel = function () {
    var r = this.lines(), total = r.lines.reduce(function (a, l) { return a + l.price; }, 0);
    var lk = this.look(), svg = this.root.querySelector('.rcgb-stage svg');
    if (svg) { ART.update(svg, lk); var lh = lensHex(lk.lens); if (lh && lh !== 'transparent') svg.style.setProperty('--bezel', lh); }
    this.updateBar(lk, total);
    var sum = this.root.querySelector('[data-sum]');
    sum.innerHTML = '<h2 class="rcgb-sum__title">Your ' + esc(this.data.m.name) + '</h2><ul class="rcgb-sum__list">' + this.displayLines(r.lines).map(function (l) {
      return '<li><span>' + esc(l.label) + (l.detail ? '<small>' + esc(l.detail) + '</small>' : '') + '</span><b>' + money(l.price) + '</b></li>';
    }).join('') + '</ul><p class="rcgb-total"><span>Total</span><b>' + money(total) + '</b></p>' +
      (r.missing.length ? '<p class="rcgb-missing" role="status">Still to choose: ' + esc(r.missing.join(', ')) + '.</p>' : '') +
      '<p class="rcgb-leadnote">Built to order · ships in an estimated ' + esc(this.lead) + '</p>' +
      (this.test ? '<p class="rcgb-testnote">Test mode: builds can\u2019t be ordered yet.</p>' : '') +
      '<button type="button" class="rcgb-add" data-add' + (r.missing.length || !r.lines.length ? ' disabled' : '') + '>' + (this.test ? 'Finish test build' : 'Add build to cart') + '</button>' +
      '<div data-testout hidden></div><p class="rcgb-msg" data-msg role="status"></p>';
    var self = this; sum.querySelector('[data-add]').onclick = function () { self.openAck(self.lines()); };
  };
  Builder.prototype.summaryText = function (r) {
    var st = this.state, total = r.lines.reduce(function (a, l) { return a + l.price; }, 0);
    return this.data.m.name + ' test build ' + st.ref + '\n' + this.displayLines(r.lines).map(function (l) {
      return '- ' + l.label + (l.detail ? ' (' + l.detail + ')' : '') + ': ' + money(l.price);
    }).join('\n') + '\nTotal: ' + money(total);
  };
  Builder.prototype.finishTest = function (r) {
    var out = this.root.querySelector('[data-testout]'), msg = this.root.querySelector('[data-msg]'), text = this.summaryText(r);
    out.hidden = false;
    out.innerHTML = '<p class="rcgb-testnote">Thanks for testing! Copy your build and send it to Retro Craft with any feedback.</p>' +
      '<label class="rcgb-testlabel" for="rcgb-test-' + this.state.ref + '">Your build</label>' +
      '<textarea class="rcgb-testtext" id="rcgb-test-' + this.state.ref + '" rows="8" readonly>' + esc(text) + '</textarea>' +
      '<button type="button" class="rcgb-copy" data-copy>Copy build</button>';
    var ta = out.querySelector('textarea');
    out.querySelector('[data-copy]').onclick = function () {
      var done = function () { msg.textContent = 'Copied. Paste it into a message to Retro Craft.'; };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, function () { ta.select(); msg.textContent = 'Select the text above and copy it.'; });
      else { ta.select(); try { document.execCommand('copy'); done(); } catch (e) { msg.textContent = 'Select the text above and copy it.'; } }
    };
    ta.focus(); ta.select();
  };
  Builder.prototype.addToCart = function (r, ackText) {
    if (this.test || !ackText) return;  // test mode never touches the cart; nothing is added without the acknowledgement
    var btn = this.root.querySelector('[data-add]'), msg = this.root.querySelector('[data-msg]'), st = this.state, name = this.data.m.name;
    btn.disabled = true; btn.textContent = 'Adding…';
    var label = name + ' custom build ' + st.ref, base = st.base === 'sendin' ? 'Send-in' : st.base === 'fpgbc' ? 'FPGBC' : 'Supplied console';
    var items = r.lines.map(function (l, i) {
      var props = { 'Build': label, '_build_ref': st.ref };
      if (l.detail) props['Option'] = l.detail;
      if (i === 0) props['Build base'] = base;
      return { id: l.id, quantity: 1, properties: props };
    });
    saveAck(ackText)
      .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) }); })
      .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw j; return j; }); })
      .then(function () { btn.textContent = 'Added to cart'; msg.innerHTML = 'Your build is in the cart. <a href="/cart">View cart</a>'; st.ref = ref(); })
      .catch(function (e) { btn.disabled = false; btn.textContent = 'Add build to cart'; msg.textContent = (e && (e.description || e.message)) || 'Something went wrong adding your build. Please try again.'; });
  };

  function start() { document.querySelectorAll('[data-rcgb]').forEach(function (el) { if (!el.__rcgb) el.__rcgb = new Builder(el); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
